// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::ng-deep .onboarding-pdf-data-modal > div > div.modal-content {
  margin-top: 50px;
}

.title {
  margin-bottom: 30px;
}

.subtitle-green {
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 150%;
  letter-spacing: -0.01em;
  color: #2B8F14;
}

ul {
  padding: 0;
}
ul li {
  list-style: none;
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 175%;
  letter-spacing: -0.01em;
  color: #44474B;
  display: flex;
}
ul li p {
  width: 90%;
}
ul li span.green-circle {
  background: #38A121;
  border-radius: 16px;
  width: 24px;
  height: 24px;
  display: inline-block;
  color: white;
  text-align: center;
  margin-right: 16px;
  margin-bottom: 20px;
}

.sub-title-gray-footer-finish-config {
  display: flex;
}
.sub-title-gray-footer-finish-config svg {
  margin-top: 3px;
}
.sub-title-gray-footer-finish-config span {
  width: 90%;
}

.tip-container .number-tip {
  float: left;
  background-color: #38A121;
  width: 25px;
  border-radius: 50%;
  text-align: center;
  line-height: 25px;
  color: #fff;
  margin: 22px 0 0 0;
}
.tip-container > label {
  display: block;
  margin-left: 40px;
  margin-top: 22px;
}

.copy-icon {
  width: 24px;
  height: 24px;
  cursor: pointer;
  margin-left: 5px;
  padding: 3px;
  border-radius: 4px;
}

a.green-text {
  font-size: 15px;
  font-family: "PFBeauSansPro", sans-serif;
  text-align: left;
  cursor: pointer;
  font-weight: bold;
  color: #2B8F14;
}
a.green-text .arrow-green {
  background-image: url("https://static-qa.fif.tech/onboarding-peru-cuentas-assets/accounts/assets/icons/generic/arrow-up-right-green.svg");
  background-repeat: no-repeat;
  display: inline-block;
  height: 20px;
  width: 15px;
  margin-top: 0px;
}

.number-detail .left-side {
  float: left;
}
.number-detail .right-side {
  font-family: "fb-thin", sans-serif;
  float: right;
  font-weight: bolder;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
